// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__f6cuC","type":"styles_type__2_k1P","choices":"styles_choices__kkZRs"};